import myApi from '@/gavnoCode/ApiHandler';

const state = {
  incomeScripts:[],
  outgoingScripts: [],
  operatorScripts: [],
  scriptsGroup: [],
};

const getters = {
  getIncomeScripts:(state)=>state.incomeScripts,
  getOutgoingScripts: (state) => state.outgoingScripts,
  getScripts: (state) => (scriptID) => {
    return state.operatorScripts.filter((item) => {
      return item.id == scriptID;
    });
  },
  getScriptNameByID: (state) => (id) => {
    let scriptName = undefined;
    let groupName = state.scriptsGroup.find((group) => {
      scriptName = group.oparatorScript.find((scr) => {
        if (scr.id == id) return scr;
      });
      if (scriptName != undefined) {
        return group;
      }
    });
    try {
      return groupName.name + ' / ' + scriptName.name;
    } catch (e) {
      return '';
    }
  }
};

const actions ={
  loadGetRefsScript: ({commit}) => {
    return new Promise((resolve, reject) => {
      if (state.scriptsGroup.length > 0) {
        resolve();
      } else {
        myApi.singleRequest({
          action: 'OperatorScript_getRefsScript',
        }).then((res) => {
          commit('setScriptsGroup', res);
          resolve();
        }).catch((res) => {
          reject('Ошибка getRefsScript');
        })
      }
    })
  },
  loadScriptById: ({commit}, scriptId) => {
    return new Promise((resolve, reject) => {
      myApi.singleRequest({
        action: 'OperatorScript_getScriptContent',
        scriptId: scriptId,
      }).then((res) => {
        if (state.operatorScripts.filter((item) => {
          return item.id == scriptId
        }).length > 0) {
          commit('updateScript', {
            id: scriptId,
            values: res
          })
        } else {
          commit('addScript', {
            id: scriptId,
            values: res
          });
        }
        resolve();
      }).catch((res) => {
        reject('Ошибка loadScriptById');
      });
    });
  },
  setScripts:({commit, dispatch}, scriptList)=>{
    let incomeArray = [];
    let outcomeArray = [];
    scriptList.forEach(function(item){
      switch (item.source) {
        case '2':
          item['showHidden'] = false;
          incomeArray.push(item);
          break;
        case '1':
          item['showHidden'] = false;
          outcomeArray.push(item);
          break;
        default:
          console.log('tut kakayato xuynya ');
          console.log(item);
          break;
      }
    });
    if (incomeArray.length > 0) {
      commit('setIncome',incomeArray);
    }
    if (outcomeArray.length > 0) {
      commit('setOutgoing',outcomeArray);
    }

  }
};

const mutations = {
  addScript: (state, newVal) => {
    state.operatorScripts.push(newVal);
  },
  updateScript: (state, newVal) => {
    state.operatorScripts = state.operatorScripts.filter((item) => {
      if (item.id == newVal.id) {
        item.values = newVal.values;
      }
      return item;
    });
  },
  setScriptsGroup: (state, newVale) => state.scriptsGroup = newVale,
  setIncome:(state, newVal)=>{
    state.incomeScripts = newVal;
  },
  setOutgoing:(state, newVal) => {
    state.outgoingScripts = newVal;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}
